<template>
<div class="chapter">
<div class="inner_page">
<h1>Larry Dexter,</h1>
<h1 class="sigil_not_in_toc">Reporter;</h1>
<h3 class="sigil_not_in_toc">Or, Strange Adventures in a Great City</h3>
<h2 class="sigil_not_in_toc">Howard Roger Garis</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?08416a93